<template>
<div>
    <vue-headful
    title="Dashboard | Select Brand"
    description="Dashboard | Select Brand"
    />

    <div>
        <nav style="position: fixed;width: 100%;height: 71px;background: #ffffff;border-bottom: 1px solid #dde1ed;z-index: 99;">
            <div style="display: flex;align-items: center;height: 100%;justify-content: space-between;margin-left: 20px;margin-right: 20px;">
                <router-link to="/dashboard/" class="btn btn-light"><i class="fa-solid fa-chevron-left mr-2"></i> Back</router-link>
            </div>
        </nav>





        <div v-if="loading_logos" style="margin: 0 auto;" class="pt-7">
        <center>
            <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
            <p class="lead">Loading...</p>
        </center>
        </div>
        <div v-else class="container">
        <div class="pt-7">
            <h1>Select your brand</h1>
            <p class="lead">Select the brand you want to get rhe Profiles and Covers.</p>
            <div v-if="logos !== null && logos.length > 0" class="row">
                <router-link v-for="(logo, index) in logos" :to="'/dashboard/profiles-and-covers/'+logo.unique_id" class="col-6 col-md-4 col-lg-3" style="margin-bottom: 20px;">
                    <div class="aumentarscale_btn" style="width: 100%; border-radius: 0.5rem;transition: transform 100ms, box-shadow 150ms;cursor: pointer;background: #FFFFFF;">
                        <div v-if="logo.paid_svglogos_s3 === 'needs_update'" class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;height: auto;">
                            <img :src="'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+timenow" style="width: 100%; border-radius: 5px;height: auto;">
                        </div>
                        <div v-else class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;height: auto;">
                            <img :src="'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+timenow" style="width: 100%; border-radius: 5px;height: auto;">
                        </div>
                    </div>
                </router-link>
            </div>
            <div v-else>
                <p class="lead">No logos created in this account.</p>
                <a href="/create/" class="btn btn-primary"><svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-jhaWeW kclIni"><path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path></svg>
                Create Logos Now</a>
            </div>
        </div>
        </div>
    </div>

</div>

</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
props:['propsdata'],
data() {
return {
    loading_logos: true,
    timenow: Date.now(),
    logos: []
};
},
methods: {
    async load_logos(){
        // Wait until propsdata paid is populated
        while (this.propsdata[0].paid === '') {
            // Wait for 100ms before checking again
            await new Promise(resolve => setTimeout(resolve, 100));
        }
        axios.post('/dashboard/cargar-logos-unique-id.php', {
        })
        .then(response => {
            this.logos = response.data;
            if(response.data === null || response.data.length <= 0){ //check if user has logos
                this.step = '2';
            }
            this.loading_logos = false;
        })
        .catch(function (error) {
        console.log(error);
        });
    }
},
mounted() {
    this.$emit('updateprops');
    this.load_logos();
},
// do not forget this section
directives: {
ClickOutside
}
};
</script>
  


// WEBPACK FOOTER //
// src/get-profiles-and-covers.vue